<!--begin::Chat-->
<div class="app-navbar-item" [ngClass]="itemClass" hidden>
  <div [ngClass]="btnClass" class="position-relative" id="kt_drawer_chat_toggle">
    <app-keenicon name="message-text-2" class="fs-2 fs-lg-1"></app-keenicon>
    <span
      class="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink">
    </span>
  </div>
</div>
<!--end::Chat-->


<!--begin::User menu-->
<div class="app-navbar-item gap-3" [ngClass]="itemClass">
  <div class="d-flex flex-wrap align-items-center gap-2" *ngIf="isVisibleUpgrade" >
    <span class="d-flex flex-wrap align-items-center"><i class="bi bi-clock mr-2 " style="color: #2dadbb;font-size: 1.20rem;"></i>Trial ends in {{trialDaysLeft}} days!</span>
    <div class="upgrade-btn mt-0" *ngIf="isVisibleUpgrade" (click)="openBulkUpgradeModal()" title="Your free trial ends in {{trialDaysLeft}} days">
      <span>Upgrade Now</span>
    </div>
  </div>
  <!--begin::Menu wrapper-->
  <div *ngIf='showUserImage' class="cursor-pointer symbol" style="display: block;width: 40px;height: 40px;"
    [ngClass]="userAvatarClass" (click)="showMenu()">
    <img [src]="UserImagePath" />
    <span class="ph-avatar--alt" *ngIf="!UserImagePath"></span>
  </div>
  <div *ngIf='showUserDp' class="cursor-pointer symbol" style="display: block;width: 40px;height: 40px;"
    [ngClass]="userAvatarClass" (click)="showMenu()">
    <span><ngx-avatar size="45" class="avatar" [name]="username"></ngx-avatar></span>
    <span class="ph-avatar--alt" *ngIf="!UserImagePath"></span>
  </div>
  <!-- <app-user-inner data-kt-menu='viewMenu' ></app-user-inner> -->
  <div *ngIf="viewMenu"
    class="fs-6 fw-bold menu menu-column menu-gray-600 menu-rounded menu-state-bg menu-state-primary menu-sub menu-sub-dropdown py-4 w-275px show"
    data-popper-placement="bottom-end"
    style="z-index: 105; position: fixed; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(-30px, 70px, 0px);">
    <p class="menu-link px-10 mt-2">
      {{roleName}}
    </p>
    <div class="separator my-2"></div>
    <div class="menu-item px-5">
      <a routerLink="/profile" (click)="closeMenu()" class="menu-link px-5">
        My Profile
      </a>
    </div>
    <div class="menu-item px-5">
      <a (click)="openBulkQuickModal()"  class="menu-link px-5">
        Quick Start Guide
      </a>
    </div>
    <div class="menu-item px-5">
      <a (click)="logout()" class="menu-link px-5 cursor-pointer"> Sign Out </a>
    </div>
  </div><!--ng-container-->

  <!--end::Menu wrapper-->
</div>
<!--end::User menu-->
<!-- <div class="image-input-wrapper w-125px h-125px bgi-position-center" id="waterImagePreview" >
  <img style="object-fit:cover;width: 100%;height: 100%;" [src]="UserImagePath" alt="Image Preview" *ngIf="UserImagePath != null || UserImagePath!=''">
</div> -->
<!--begin::Header menu toggle-->
<ng-container *ngIf="appHeaderDefaulMenuDisplay">
  <div class="app-navbar-item d-lg-none ms-2 me-n3" title="Show header menu" hidden>
    <div class="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_header_menu_toggle">
      <app-keenicon name="text-align-left" class="" [ngClass]="btnIconClass"></app-keenicon>
    </div>
  </div>
</ng-container>
<!--end::Header menu toggle-->

<ng-template #bulkUpgradeModal>
  <div class="modal-content">

    <div class="modal-header py-5">
      <!--begin::Modal title-->
      <h4 class="m-0">Request Plan Upgrade</h4>
      <!--end::Modal title-->
      <div type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></div>
    </div>

    <div class="modal-body">
    <div class="upgrade-filter">
  <!-- Pricing Tiers -->
  <div class="mb-4">
    <label class="form-label fw-medium d-flex">Pricing Tiers</label>
    <div class="d-flex justify-content-between gap-3 flex-wrap mt-3">
    <div
      *ngFor="let tier of pricingTiers; let i = index"
      class="tier-card p-3 border rounded text-center cursor-pointer"
      [ngClass]="{ 'active-tier': selectedTierIndex === i }"
      (click)="selectTier(i)"
    >
      <div class="fw-bold">{{ tier.range }}</div>
      <div class="text-muted small">
        {{ tier.monthly }} AED /mo<br />
        {{ tier.yearly }} AED /yr
      </div>
    </div>
  </div>
  </div>

  <!-- Number of Users -->
  <div class="mb-4 pb-2">
    <label class="form-label fw-medium d-flex">Number of Users</label>
    <div class="input-group user-count">
      <button class="btn btn-outline-secondary" type="button" (click)="decreaseUsers()"><i class="bi bi-dash"></i></button>
      <input type="text" class="form-control text-center" [value]="userCount" readonly>
      <button class="btn btn-outline-secondary" type="button" (click)="increaseUsers()"><i class="bi bi-plus-lg"></i></button>
    </div>
    <div *ngIf="usersToNextTier !== null">
      <p class="text-warning unlock-user mt-3"><i class="bi bi-exclamation-circle"></i> Add {{ usersToNextTier }} more
        user{{ usersToNextTier > 1 ? 's' : '' }} to unlock lower pricing</p>
    </div>    
  </div>

  <!-- Billing Cycle -->
  <div class="mb-4">
    <label class="form-label fw-medium">Billing Cycle</label>
    <div class="row g-3">
      <div class="col-md-6">
        <div class="billing-option" [ngClass]="{'active': isMonthly}" (click)="selectBilling(true)">
          <div class="fw-bold mb-2">Monthly</div>
          <div class="text-muted">AED {{ selectedTier.monthly }} /user</div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="billing-option" [ngClass]="{'active': !isMonthly}" (click)="selectBilling(false)">
          <div class="fw-bold mb-2">Yearly</div>
          <div class="text-muted">AED {{ selectedTier.yearly }} /user</div>
          <div class="savings-text">Save {{ discountPercentage }}%</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Price Summary -->
  <div class="price-estimate p-4 rounded-3 mb-4">
    <div class="mb-3 d-flex justify-content-between align-items-center">
      <div class="text-dark fw-medium fs-4">Price Summary</div>
      <div class="badge-summary"><span class="badge badge-success fw-normal">{{ discountPercentage }}% of standard price</span></div>
    </div>
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <div class="text-muted fw-medium">Price per user:</div>
      <div class="fw-medium">AED {{ pricePerUser }}</div>
    </div>
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <div class="text-muted fw-medium">Number of users:</div>
      <div class="fw-medium">{{ userCount }}</div>
    </div>
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <div class="text-muted fw-medium">Billing cycle:</div>
      <div class="fw-medium">{{ isMonthly ? 'Monthly' : 'Yearly' }}</div>
    </div>
    <div class="d-flex justify-content-between align-items-center fs-5 fw-bold pt-4 mt-4 border-top">
      <div>Total amount:</div>
      <div class="text-right">AED {{ totalPrice }} <span class="fs-8 text-muted fw-medium d-block">per month, billed {{ isMonthly ? 'monthly' : 'yearly' }}</span></div>
    </div>
  </div>

  <p class="text-muted mb-0">Upon submission, our team will review your request and get back to you regarding payment processing.</p>
</div>

    </div>

    <div class="modal-footer gap-3">
      <button class="btn btn-link text-dark text-decoration-none" (click)="closeModal()">Cancel</button>
      <button class="btn btn-sm btn-primary" (click)="sendRequest()">Send Upgrade Request</button>
    </div>

  </div>
</ng-template>

<ng-template #bulkQuickStartModal>
  <div class="modal-content quick-start-modal">

    <div class="modal-header py-5">
      <div class="d-flex flex-column align-items-center w-100">
          <h1>Welcome to PropHero</h1>
          <p class="subtitle">Here is your quick start guide!</p>
      </div>
      <div type="button" class="btn-close" aria-label="Close" (click)="closeQuickModal()"></div>
    </div>

    <div class="modal-body">
      <div class="popup-content">
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              🏠 Listings
              <a href="http://test.prophero.net/listings" class="redirect-icon" target="_blank" rel="noopener noreferrer">↗</a>
            </div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Create listings by entering property details and selecting portals to publish them. Use 'Listing Quality' to
                ensure portal compliance.
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Use previews to create shareable listing links for clients. Manage all listings from the main view with full
                edit/filter/export controls.
              </div>
            </div>
          </div>
        </div>
      
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              👥 Contacts and Leads
                <a href="http://test.prophero.net/leads" class="redirect-icon" target="_blank" rel="noopener noreferrer">↗</a>
            </div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Create new contacts and leads manually or bulk import them. Once leads integration is configured, leads from
                portals will automatically appear in the leads module.
              </div>
            </div>
          </div>
        </div>
      
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              👁️ Viewings
              <a href="http://test.prophero.net/viewings" class="redirect-icon" target="_blank" rel="noopener noreferrer">↗</a>
            </div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Create viewings by linking your listings to leads and setting the appointment time.
              </div>
            </div>
          </div>
        </div>
      
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              🤝 Deals
              <a href="http://test.prophero.net/deals" class="redirect-icon" target="_blank" rel="noopener noreferrer">↗</a>
            </div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Create deals by linking listings to leads, enter transaction details, and manage everything from the main list
                view.
              </div>
            </div>
          </div>
        </div>
      
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              📊 Reports
               <a href="http://test.prophero.net/reports/listings" class="redirect-icon" target="_blank" rel="noopener noreferrer">↗</a>
            </div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Explore the standard reports of Listings, Leads, Viewings, Deals and Agents.
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Build custom Lead reports with flexible performance metrics and dimensions.
              </div>
            </div>
          </div>
        </div>
      
        <div class="section">
          <div class="section-header">
            <div class="section-title">
              🏗️ Projects
              <a href="http://test.prophero.net/projects" class="redirect-icon" target="_blank" rel="noopener noreferrer">↗</a>
            </div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Upload project brochures and let PropHero AI automatically extract details and images.
              </div>
            </div>
          </div>
        </div>
      
        <div class="section">
          <div class="section-header">
            <div class="section-title">📱 Mobile App</div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Download iOS and Android apps to manage your business on the go.
              </div>
            </div>
            <button class="download-btn" onclick="window.open('/ios-app', '_blank')">Download iOS</button>
            <button class="download-btn" onclick="window.open('/android-app', '_blank')">Download Android</button>
          </div>
        </div>
      
        <div class="section" *ngIf="isAdmin">
          <div class="section-header">
            <div class="section-title">
              ⚙️ Settings <span class="admin-only">Admin Only</span>
              <a href="http://test.prophero.net/settings/company" class="redirect-icon" target="_blank" rel="noopener noreferrer">↗</a>
            </div>
          </div>
          <div class="section-content">
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Add new Users and manage User Allowances
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Add company details and marketing images
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Configure listings integration by enabling portals and accessing XML links
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Set up leads integration with API keys and secret keys
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Create Teams and custom Roles for better collaboration
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-bullet"></div>
              <div class="feature-text">
                Use Automation to automate assignment and rotation of leads
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="cta-section">
        <button class="cta-button" onclick="startTour()">Take a Quick Tour</button>
        <button class="skip-btn" onclick="closePopup()">I'll explore on my own</button>
      </div> -->
    </div>


  </div>
</ng-template>